import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import GeneratorLayout from 'layout/GeneratorLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const GeneratorPage = Loadable(lazy(() => import('views/generator-page')));

// ==============================|| MAIN ROUTING ||============================== //

const NewCampaignRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <GeneratorLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/generator/:type/:id',
            element: <GeneratorPage />
        }
    ]
};

export default NewCampaignRoutes;
